module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-00.1@2x.44715c90.jpg";